// i18n utility functions
import koTranslations from './locales/ko.json';
import enTranslations from './locales/en.json';
import jaTranslations from './locales/ja.json';

// Available languages
export const LANGUAGES = {
  ko: { code: 'ko', name: '한국어', translations: koTranslations },
  en: { code: 'en', name: 'English', translations: enTranslations },
  ja: { code: 'ja', name: '日本語', translations: jaTranslations }
};

export const DEFAULT_LANGUAGE = 'ko';
const STORAGE_KEY = 'astrantis_language';

/**
 * Get browser's preferred language
 * @returns {string} Language code (ko, en, ja)
 */
export const getBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  
  // Extract language code (e.g., 'en-US' -> 'en')
  const langCode = browserLang.split('-')[0].toLowerCase();
  
  // Return if supported, otherwise default
  return LANGUAGES[langCode] ? langCode : DEFAULT_LANGUAGE;
};

/**
 * Get saved language from localStorage
 * @returns {string|null} Saved language code or null
 */
export const getSavedLanguage = () => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch (error) {
    console.error('Error reading language from localStorage:', error);
    return null;
  }
};

/**
 * Save language to localStorage
 * @param {string} language - Language code to save
 */
export const saveLanguage = (language) => {
  try {
    localStorage.setItem(STORAGE_KEY, language);
  } catch (error) {
    console.error('Error saving language to localStorage:', error);
  }
};

/**
 * Get initial language (saved > browser > default)
 * @returns {string} Language code
 */
export const getInitialLanguage = () => {
  const saved = getSavedLanguage();
  if (saved && LANGUAGES[saved]) {
    return saved;
  }
  
  return getBrowserLanguage();
};

/**
 * Get translation for a key
 * @param {string} language - Current language code
 * @param {string} key - Translation key (e.g., 'nav.home')
 * @returns {string} Translated text
 */
export const translate = (language, key) => {
  const translations = LANGUAGES[language]?.translations;
  
  if (!translations) {
    console.warn(`Language not found: ${language}`);
    return key;
  }
  
  // Support nested keys (e.g., 'nav.home')
  const keys = key.split('.');
  let value = translations;
  
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      console.warn(`Translation key not found: ${key} for language: ${language}`);
      return key;
    }
  }
  
  return typeof value === 'string' || Array.isArray(value) ? value : key;
};

